import React, { Component } from "react"

import UserEmailAddressEditList from "./UserEmailAddressEditList"

class EmailAddressAddWidget extends Component {
    constructor(props) {
        super(props)
        this.state = {
            emailToAdd: ""
        }

        this.updateEmail = this.updateEmail.bind(this)
        this.addEmail = this.addEmail.bind(this)
    }

    addEmail(event) {
        event.preventDefault()
        const emails = [...this.props.emails, this.state.emailToAdd]
        this.props.onValueChange("emails")(emails)
    }

    updateEmail(event) {
        this.setState({
            emailToAdd: event.target.value
        })
    }

    render() {
        return (
            <div className="widget">
                <h3 className="widget-header">
                    <i className="icon icon-user-email-address" />Email
                    Addresses
                </h3>
                <form className="row" onSubmit={this.addEmail}>
                    <div className="search-bar-container col-xs-10 col-10">
                        <input
                            type="email"
                            name="email_address"
                            className="form-control"
                            placeholder="Email Address"
                            onChange={this.updateEmail}
                            value={this.state.emailToAdd}
                        />
                    </div>
                    <div className="col-xs-2 col-2">
                        <button
                            className="btn btn-primary widget-header-button"
                            type="submit"
                        >
                            Add
                        </button>
                    </div>
                </form>
                <div className="widget-content">
                    <UserEmailAddressEditList
                        emails={this.props.emails}
                        primary_email={this.props.primary_email}
                        onChange={this.props.onValueChange("primary_email")}
                        onDelete={this.props.onValueChange("emails")}
                    />
                </div>
            </div>
        )
    }
}

export default EmailAddressAddWidget
